import { orderErrorCodeOf } from '@/shared/lib';

const NOT_FOUND_CODES: readonly string[] = ['ORDER_NOT_FOUND', 'NOT_OWNER'];

/** 내 주문 상세 거절이 "없는 주문·남의 주문"인지 — 둘 다 같은 못 찾음 화면으로 존재를 드러내지 않는다. */
export const isMyOrderNotFound = (error: unknown): boolean => {
  const code = orderErrorCodeOf(error);
  return code !== null && NOT_FOUND_CODES.includes(code);
};
